import React from 'react';
import styles from './DayTimeline.module.css';

const DayTimeline = ({ timeEntries }) => {
  // Convert all time entries to timeline blocks
  const timelineBlocks = timeEntries.flatMap(group =>
    group.entries.map(entry => ({
      startTime: new Date(entry.startTime),
      endTime: entry.endTime ? new Date(entry.endTime) : new Date(),
      ticketTitle: group.ticket.title,
      duration: entry.duration,
      stepText: entry.stepText
    }))
  );

  // Helper function to convert time to percentage of day (0-100%)
  const timeToPercent = (date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const totalMinutes = hours * 60 + minutes + seconds / 60;
    return (totalMinutes / (24 * 60)) * 100;
  };

  // Helper function to format time
  const formatTime = (date) => {
    return date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
  };

  // Generate hour markers (every 2 hours for compact display)
  const hourMarkers = [0, 6, 12, 18, 24].map(hour => ({
    hour,
    position: (hour / 24) * 100
  }));

  return (
    <div className={styles.timelineContainer}>
      <div className={styles.timelineHeader}>
        <h4>Tagesübersicht (24h)</h4>
      </div>

      <div className={styles.timeline}>
        {/* Hour markers */}
        <div className={styles.hourMarkers}>
          {hourMarkers.map(({ hour, position }) => (
            <div
              key={hour}
              className={styles.hourMarker}
              style={{ left: `${position}%` }}
            >
              <div className={styles.hourLine} />
              <div className={styles.hourLabel}>{hour}:00</div>
            </div>
          ))}
        </div>

        {/* Work blocks */}
        <div className={styles.workBlocks}>
          {timelineBlocks.map((block, index) => {
            const startPercent = timeToPercent(block.startTime);
            const endPercent = timeToPercent(block.endTime);
            const width = endPercent - startPercent;

            return (
              <div
                key={index}
                className={styles.workBlock}
                style={{
                  left: `${startPercent}%`,
                  width: `${width}%`
                }}
                title={`${block.ticketTitle}\n${formatTime(block.startTime)} - ${formatTime(block.endTime)}\n${block.stepText || ''}`}
              >
                <div className={styles.workBlockContent}>
                  <span className={styles.workBlockTime}>
                    {formatTime(block.startTime)}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DayTimeline;
